const menu = {
  label: '• Complexidade Metodologia',
  to: '/sol/complexidademetodologia',
  rules: ['SOL-001'],
}

export default menu;